(function () {
  'use strict';

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency || 'EUR' }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function moveGalleryArrows(row, previous, next) {
    if (!row) return;
    [previous, next].forEach(function (arrow, index) {
      if (!arrow) return;
      arrow.classList.add('pf-gallery-nav-arrow');
      arrow.classList.toggle('pf-gallery-nav-arrow--prev', index === 0);
      arrow.textContent = '';
      if (index === 0) row.insertBefore(arrow, row.firstChild);
      else row.appendChild(arrow);
    });
  }

  function initGallery(section) {
    var gallery = section.querySelector('[data-v17-gallery]');
    if (!gallery || gallery.dataset.v17Ready === 'true') return;
    gallery.dataset.v17Ready = 'true';
    gallery.querySelectorAll('img').forEach(function (image) { image.draggable = false; });

    var matImages = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-image]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var thumbRow = gallery.querySelector('[data-gallery-thumbs]');
    var bundleImages = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-bundle-image]'));
    var bundleThumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-bundle-thumb]'));
    var bundleThumbRow = gallery.querySelector('[data-bundle-thumbs]');
    var explainers = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-bundle-kind="functions"]'));
    var explainer = explainers[0];
    var explainerLink = null;
    if (explainer) {
      explainers.forEach(function (slide, index) {
      bundleImages.splice(bundleImages.indexOf(slide), 1);
      bundleImages.splice(Math.min(index + 1, bundleImages.length), 0, slide);
      var explainerThumb = document.createElement('button');
      explainerThumb.type = 'button';
      explainerThumb.className = 'pf-v17-gallery__thumb pf-bottle-explainer-thumb';
      explainerThumb.setAttribute('aria-label', slide.dataset.functionTitle + ' anzeigen');
      var thumbImage = slide.querySelector('img').cloneNode();
      thumbImage.alt = '';
      explainerThumb.appendChild(thumbImage);
      bundleThumbs.splice(index + 1, 0, explainerThumb);
      if (bundleThumbRow) bundleThumbRow.insertBefore(explainerThumb, bundleThumbRow.children[index + 1] || null);
      });

    }
    // Show the mat's buying information in the bundle gallery as well.
    matImages.filter(function (image) { return image.hasAttribute('data-mat-info'); }).forEach(function (image, index) {
      var slide = image.cloneNode();
      slide.removeAttribute('data-gallery-image');
      slide.removeAttribute('data-gallery-index');
      slide.setAttribute('data-gallery-bundle-image', '');
      slide.dataset.galleryBundleKind = 'mat-info';
      slide.hidden = true;
      gallery.querySelector('[data-offer-medium="bundle"]').appendChild(slide);
      bundleImages.splice(index + 1, 0, slide);
      var thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'pf-v17-gallery__thumb';
      thumb.setAttribute('aria-label', image.alt + ' anzeigen');
      var preview = image.cloneNode();
      preview.removeAttribute('data-gallery-image');
      preview.removeAttribute('data-mat-info');
      preview.hidden = false;
      preview.alt = '';
      thumb.appendChild(preview);
      bundleThumbs.splice(index + 1, 0, thumb);
      if (bundleThumbRow) bundleThumbRow.insertBefore(thumb, bundleThumbRow.children[index + 1] || null);
    });
    var colors = section.querySelector('[data-bundle-colors]');
    var bundleNote = section.querySelector('[data-bundle-note]');
    var offerChoices = Array.prototype.slice.call(section.querySelectorAll('[data-offer-choice]'));
    var colorChoices = Array.prototype.slice.call(section.querySelectorAll('[data-bundle-variant]'));
    var currentIndex = 0;
    var currentBundleIndex = 0;
    var promo = section.querySelector('[data-bundle-promo]');
    function updatePromo() {
      if (!promo) return;
      var selectedBundle = offerChoices.some(function (choice) { return choice.checked && choice.value === 'bundle'; });
      var color = colorChoices.find(function (choice) { return choice.checked; });
      var promoOffer = selectedBundle ? (color && { price: Number(color.dataset.price), compare: Number(color.dataset.compare) }) : offerData.offers.mat;
      var remaining = Date.parse(promo.dataset.promoEnd) - Date.now();
      promo.hidden = !promoOffer || !(promoOffer.compare > promoOffer.price) || !(remaining > 0);
      if (promo.hidden) return;
      promo.querySelector('strong').textContent = selectedBundle ? 'Bundle-Angebot nur für kurze Zeit' : 'HeckHeld-Angebot nur für kurze Zeit';
      var minutes = Math.ceil(remaining / 60000);
      promo.querySelector('[data-promo-remaining]').textContent = 'Noch ' + Math.floor(minutes / 1440) + ' Tage · ' + Math.floor(minutes % 1440 / 60) + ' Std. · ' + minutes % 60 + ' Min.';
      promo.querySelector('[data-promo-regular-price]').textContent = formatMoney(selectedBundle ? 5997 : 4886, offerData.currency);
      promo.querySelector('[data-promo-price-suffix]').textContent = selectedBundle ? ' für die gewählte Farbe.' : ' für die HeckHeld Matte.';
    }
    if (promo) {
      var promoTimer = window.setInterval(function () {
        if (!section.isConnected) { window.clearInterval(promoTimer); return; }
        updatePromo();
        if (Date.now() >= Date.parse(promo.dataset.promoEnd)) window.clearInterval(promoTimer);
      }, 15000);
    }
    function makeDots(images, label, select, arrowPrefix) {
      var row = document.createElement('div');
      row.className = 'pf-gallery-dots';
      row.setAttribute('aria-label', label);
      row.hidden = images.length < 2;
      images.forEach(function (_, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pf-gallery-dot';
        dot.setAttribute('aria-label', label + ' ' + (index + 1) + ' anzeigen');
        dot.addEventListener('click', function () { select(index); });
        row.appendChild(dot);
      });
      moveGalleryArrows(row, gallery.querySelector('[' + arrowPrefix + 'prev]'), gallery.querySelector('[' + arrowPrefix + 'next]'));
      gallery.appendChild(row);
      return row;
    }
    var matDots = makeDots(matImages, 'Produktbild', showMat, 'data-gallery-');
    var bundleDots = makeDots(bundleImages, 'Bundlebild', selectBundleGallery, 'data-bundle-gallery-');
    function markDot(row, index) {
      Array.prototype.forEach.call(row.querySelectorAll('.pf-gallery-dot'), function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }
    var galleryPointerStart = null;
    var offerData = { currency: 'EUR', offers: {} };
    var dataNode = section.querySelector('[data-offer-data]');
    try { offerData = JSON.parse(dataNode.textContent); } catch (error) { /* Shopify still submits without this enhancement. */ }

    function showPhotoCaption(slide) {
      var caption = gallery.querySelector('[data-real-caption]');
      if (!caption) return;
      var isPhoto = slide && slide.dataset.photoTitle;
      caption.hidden = !isPhoto;
      if (!isPhoto) return;
      caption.querySelector('[data-real-caption-title]').textContent = slide.dataset.photoTitle;
      caption.querySelector('[data-real-caption-copy]').textContent = slide.dataset.photoCopy || '';
      var link = caption.querySelector('[data-real-caption-link]');
      link.hidden = !slide.dataset.photoOriginal;
      if (slide.dataset.photoOriginal) link.href = slide.dataset.photoOriginal;
    }

    function showMat(index) {
      if (!matImages.length) return;
      currentIndex = (index + matImages.length) % matImages.length;
      markDot(matDots, currentIndex);
      showPhotoCaption(matImages[currentIndex]);
      matImages.forEach(function (image, imageIndex) { image.hidden = imageIndex !== currentIndex; });
      thumbs.forEach(function (thumb, thumbIndex) {
        var active = thumbIndex === currentIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function showBundle(index) {
      if (!bundleImages.length) return;
      currentBundleIndex = (index + bundleImages.length) % bundleImages.length;
      markDot(bundleDots, currentBundleIndex);
      showPhotoCaption(bundleImages[currentBundleIndex]);
      bundleImages.forEach(function (image, imageIndex) { image.hidden = imageIndex !== currentBundleIndex; });
      var bundleLabel = gallery.querySelector('.pf-v17-gallery__bundle-label');
      if (bundleLabel) bundleLabel.hidden = bundleImages[currentBundleIndex].dataset.galleryBundleKind !== 'set';
      bundleThumbs.forEach(function (thumb, thumbIndex) {
        var active = thumbIndex === currentBundleIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function activeQuantity() {
      var form = section.querySelector('[data-offer-form="bundle"]');
      var input = form && form.querySelector('[data-offer-quantity]');
      return Math.max(1, Math.floor(Number(input && input.value) || 1));
    }

    function syncBundleVariant(choice) {
      if (!choice) return;
      var variantId = choice.value;
      var colorLabel = choice.dataset.colorLabel || '';
      var price = Number(choice.dataset.price || 0);
      var compare = Number(choice.dataset.compare || 0);
      var quantity = activeQuantity();
      var available = choice.dataset.available === 'true';
      var form = section.querySelector('[data-offer-form="bundle"]');
      var button = form && form.querySelector('[data-offer-submit]');
      var selectedColor = section.querySelector('[data-selected-bundle-color]');
      var detail = section.querySelector('[data-bundle-card-detail]');
      var priceNode = section.querySelector('[data-offer-price]');
      var compareNode = section.querySelector('[data-offer-compare]');
      var savingNode = section.querySelector('[data-offer-saving]');
      var cardPrice = section.querySelector('[data-card-price="bundle"]');
      var cardSaving = section.querySelector('[data-card-saving="bundle"]');
      var stickyPrice = document.querySelector('[data-sticky-owner="' + section.dataset.productSectionId + '"] [data-sticky-price]');
      var stickyName = document.querySelector('[data-sticky-owner="' + section.dataset.productSectionId + '"] [data-sticky-name]');
      var stickyImage = document.querySelector('[data-sticky-owner="' + section.dataset.productSectionId + '"] [data-sticky-image]');
      var stickySubmit = document.querySelector('[data-sticky-owner="' + section.dataset.productSectionId + '"] [data-offer-sticky-submit]');
      var targetIndex = bundleImages.findIndex(function (image) { return image.dataset.galleryBundleVariant === variantId && image.dataset.galleryBundleKind === 'set'; });
      showBundle(targetIndex >= 0 ? targetIndex : 0);
      if (selectedColor) selectedColor.textContent = colorLabel;
      gallery.querySelectorAll('[data-real-bundle-bottle]').forEach(function (image) {
        if (choice.dataset.image) image.src = choice.dataset.image;
        image.alt = 'PfotenFlasche in ' + colorLabel;
      });
      gallery.querySelectorAll('[data-real-bundle-color]').forEach(function (node) { node.textContent = colorLabel; });
      var cardBottle = section.querySelector('[data-bundle-card-bottle]');
      if (cardBottle && choice.dataset.image) {
        cardBottle.src = choice.dataset.image;
        cardBottle.alt = 'PfotenFlasche in ' + colorLabel;
      }
      if (detail) detail.textContent = '1 Matte + 1 Flasche in ' + colorLabel;
      if (cardPrice) cardPrice.textContent = formatMoney(price, offerData.currency);
      var cardCompare = section.querySelector('[data-bundle-card-compare]');
      if (cardCompare) {
        cardCompare.hidden = !(compare > price);
        cardCompare.textContent = formatMoney(compare, offerData.currency);
      }
      if (priceNode) priceNode.textContent = formatMoney(price * quantity, offerData.currency);
      if (compareNode) {
        compareNode.hidden = !(compare > price);
        compareNode.textContent = compare > price ? formatMoney(compare * quantity, offerData.currency) : '';
      }
      var amount = Math.max(0, compare - price);
      var percent = compare > price ? Math.round(amount / compare * 1000) / 10 : 0;
      var savingText = amount > 0 ? '−' + String(Math.round(percent)).replace('.', ',') + ' % sparen' : '';
      if (savingNode) { savingNode.hidden = !savingText; savingNode.textContent = savingText; }
      if (cardSaving) { cardSaving.textContent = savingText; cardSaving.hidden = !savingText; }
      if (button) { button.disabled = !available; button.textContent = available ? button.dataset.defaultLabel : 'Diese Farbe ist ausverkauft'; }
      if (stickyPrice) stickyPrice.textContent = formatMoney(price * quantity, offerData.currency);
      if (stickyName) stickyName.textContent = 'HeckHeld + PfotenFlasche · ' + colorLabel;
      if (stickyImage && choice.dataset.image) stickyImage.src = choice.dataset.image;
      if (stickySubmit) stickySubmit.disabled = !available;
      updatePromo();
    }

    function syncOfferEnhancements() {
      var selectedOffer = offerChoices.find(function (choice) { return choice.checked; });
      var isBundle = selectedOffer && selectedOffer.value === 'bundle';
      if (thumbRow) thumbRow.hidden = isBundle;
      matDots.hidden = isBundle || matImages.length < 2;
      bundleDots.hidden = !isBundle || bundleImages.length < 2;
      if (bundleThumbRow) bundleThumbRow.hidden = !isBundle;
      if (colors) colors.hidden = !isBundle;
      if (bundleNote) bundleNote.hidden = !isBundle;
      if (explainerLink) explainerLink.hidden = !isBundle;
      if (isBundle) syncBundleVariant(colorChoices.find(function (choice) { return choice.checked; }) || colorChoices.find(function (choice) { return !choice.disabled; }));
      else showMat(currentIndex);
      updatePromo();
    }

    thumbs.forEach(function (thumb, index) { thumb.addEventListener('click', function () { showMat(index); }); });
    function selectBundleGallery(index) {
      if (!bundleImages.length) return;
      var normalized = (index + bundleImages.length) % bundleImages.length;
      var target = bundleImages[normalized];
      var choice = colorChoices.find(function (item) { return item.value === target.dataset.galleryBundleVariant; });
      if (choice && !choice.disabled && !choice.checked) {
        choice.checked = true;
        syncBundleVariant(choice);
      }
      showBundle(normalized);
    }
    bundleThumbs.forEach(function (thumb, index) { thumb.addEventListener('click', function () { selectBundleGallery(index); }); });
    var previous = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    var bundlePrevious = gallery.querySelector('[data-bundle-gallery-prev]');
    var bundleNext = gallery.querySelector('[data-bundle-gallery-next]');
    if (previous) previous.addEventListener('click', function () { showMat(currentIndex - 1); });
    if (next) next.addEventListener('click', function () { showMat(currentIndex + 1); });
    if (bundlePrevious) bundlePrevious.addEventListener('click', function () { selectBundleGallery(currentBundleIndex - 1); });
    if (bundleNext) bundleNext.addEventListener('click', function () { selectBundleGallery(currentBundleIndex + 1); });
    gallery.querySelectorAll('[data-offer-medium]').forEach(function (stage) {
      stage.addEventListener('pointerdown', function (event) {
        galleryPointerStart = { x: event.clientX, y: event.clientY, medium: stage.dataset.offerMedium };
      });
      stage.addEventListener('pointerup', function (event) {
        if (!galleryPointerStart || galleryPointerStart.medium !== stage.dataset.offerMedium) return;
        var deltaX = event.clientX - galleryPointerStart.x;
        var deltaY = event.clientY - galleryPointerStart.y;
        galleryPointerStart = null;
        if (Math.abs(deltaX) <= 42 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        if (stage.dataset.offerMedium === 'bundle') selectBundleGallery(currentBundleIndex + (deltaX < 0 ? 1 : -1));
        else showMat(currentIndex + (deltaX < 0 ? 1 : -1));
      });
      stage.addEventListener('pointercancel', function () { galleryPointerStart = null; });
    });
    offerChoices.forEach(function (choice) { choice.addEventListener('change', syncOfferEnhancements); });
    colorChoices.forEach(function (choice) { choice.addEventListener('change', function () { if (choice.checked) syncBundleVariant(choice); }); });
    section.querySelectorAll('[data-offer-form="bundle"] [data-offer-quantity]').forEach(function (input) {
      input.addEventListener('input', function () { syncBundleVariant(colorChoices.find(function (choice) { return choice.checked; })); });
      input.addEventListener('change', function () { syncBundleVariant(colorChoices.find(function (choice) { return choice.checked; })); });
    });
    showMat(0);
    window.requestAnimationFrame(syncOfferEnhancements);
  }

  function initTaskVideo(video) {
    if (!video || video.dataset.v17Ready === 'true') return;
    video.dataset.v17Ready = 'true';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function showPoster() {
      if (!video.poster || video.nextElementSibling && video.nextElementSibling.matches('.pf-v17-video-fallback')) return;
      var fallback = document.createElement('img');
      fallback.className = 'pf-v17-video-fallback';
      fallback.src = video.poster;
      fallback.alt = 'Vorschaubild des Pfotenfahrt Produktvideos';
      fallback.width = 1280;
      fallback.height = 720;
      video.hidden = true;
      video.parentNode.insertBefore(fallback, video.nextSibling);
    }
    video.addEventListener('error', showPoster);
    if (reduceMotion) { video.removeAttribute('autoplay'); video.pause(); showPoster(); return; }
    var playRequest = video.play();
    if (playRequest && typeof playRequest.catch === 'function') playRequest.catch(showPoster);
  }

  function initBottleCoverflow(carousel) {
    if (!carousel || carousel.dataset.v17Ready === 'true') return;
    carousel.dataset.v17Ready = 'true';
    carousel.querySelectorAll('img').forEach(function (image) { image.draggable = false; });

    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-bottle-slide]'));
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-bottle-dot]'));
    var previous = carousel.querySelector('[data-bottle-prev]');
    var next = carousel.querySelector('[data-bottle-next]');
    moveGalleryArrows(carousel.querySelector('.pf-gallery-dots'), previous, next);
    var toggle = carousel.querySelector('[data-bottle-toggle]');
    var status = carousel.querySelector('[data-bottle-status]');
    var viewport = carousel.querySelector('.pf-bottle-coverflow__viewport');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var current = 0;
    var timer = null;
    var userPaused = reduceMotion.matches;
    var interactionPaused = false;
    var isVisible = true;
    var pointerStart = null;

    if (slides.length < 2) return;

    function circularOffset(index) {
      var offset = index - current;
      var halfway = slides.length / 2;
      if (offset > halfway) offset -= slides.length;
      if (offset < -halfway) offset += slides.length;
      return offset;
    }

    function paint() {
      var compact = window.matchMedia('(max-width: 700px)').matches;
      slides.forEach(function (slide, index) {
        var offset = circularOffset(index);
        var distance = Math.abs(offset);
        var direction = offset < 0 ? -1 : 1;
        var shiftSteps = compact ? [0, 54, 96, 126] : [0, 58, 102, 132];
        var shift = direction * (distance > 3 ? 145 : shiftSteps[distance]);
        var rotate = distance ? direction * -1 * (38 + Math.min(distance - 1, 2) * 6) : 0;
        var scale = Math.max(.7, 1 - distance * .09);
        var active = distance === 0;
        var concealed = distance > 3;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.style.zIndex = String(10 - distance);
        slide.style.opacity = concealed ? '0' : String(Math.max(.16, 1 - distance * .25));
        slide.style.visibility = concealed ? 'hidden' : 'visible';
        slide.style.filter = distance ? 'saturate(.82) brightness(.92)' : 'none';
        slide.style.transform = 'translate3d(' + shift + '%, 0, ' + (90 - distance * 135) + 'px) rotateY(' + rotate + 'deg) scale(' + scale + ')';
      });
      dots.forEach(function (dot, index) {
        if (index === current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (status) status.textContent = 'Bild ' + (current + 1) + ' von ' + slides.length;
    }

    function stopTimer() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function startTimer() {
      stopTimer();
      if (reduceMotion.matches || userPaused || interactionPaused || !isVisible || document.hidden) return;
      timer = window.setInterval(function () {
        current = (current + 1) % slides.length;
        paint();
      }, 3000);
    }

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      paint();
      startTimer();
    }

    function syncToggle() {
      if (!toggle) return;
      toggle.hidden = reduceMotion.matches;
      toggle.setAttribute('aria-label', userPaused ? 'Automatische Drehung fortsetzen' : 'Automatische Drehung pausieren');
      var symbol = toggle.querySelector('span');
      if (symbol) symbol.textContent = userPaused ? '▶' : 'Ⅱ';
    }

    if (previous) previous.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (dot, index) { dot.addEventListener('click', function () { goTo(index); }); });
    if (toggle) toggle.addEventListener('click', function () {
      userPaused = !userPaused;
      syncToggle();
      startTimer();
    });

    carousel.addEventListener('mouseenter', function () { interactionPaused = true; stopTimer(); });
    carousel.addEventListener('mouseleave', function () { interactionPaused = false; startTimer(); });
    carousel.addEventListener('focusin', function () { interactionPaused = true; stopTimer(); });
    carousel.addEventListener('focusout', function (event) {
      if (event.relatedTarget && carousel.contains(event.relatedTarget)) return;
      interactionPaused = false;
      startTimer();
    });
    carousel.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(current - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(current + 1); }
    });

    if (viewport) {
      viewport.addEventListener('pointerdown', function (event) { pointerStart = { x: event.clientX, y: event.clientY }; });
      viewport.addEventListener('pointerup', function (event) {
        if (!pointerStart) return;
        var deltaX = event.clientX - pointerStart.x;
        var deltaY = event.clientY - pointerStart.y;
        pointerStart = null;
        if (Math.abs(deltaX) > 42 && Math.abs(deltaX) > Math.abs(deltaY)) goTo(current + (deltaX < 0 ? 1 : -1));
      });
      viewport.addEventListener('pointercancel', function () { pointerStart = null; });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        isVisible = entries[0] && entries[0].isIntersecting;
        startTimer();
      }, { threshold: .25 }).observe(carousel);
    }

    document.addEventListener('visibilitychange', startTimer);
    window.addEventListener('resize', paint);
    if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', function () {
      userPaused = reduceMotion.matches;
      syncToggle();
      paint();
      startTimer();
    });

    paint();
    syncToggle();
    startTimer();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-offer-buybox]').forEach(initGallery);
    (root || document).querySelectorAll('[data-v17-task-video]').forEach(initTaskVideo);
    (root || document).querySelectorAll('[data-bottle-coverflow]').forEach(initBottleCoverflow);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
